import React from 'react';
import PropTypes from 'prop-types';
import { TaskNotifications } from 'application/dashboard/components';
import { NotifyOutsideClick } from 'core/components';
import {defaultTemplate} from 'core/hoc';

function GlobalTaskNotificationsTemplate({ globalTaskNotificationsStore }) {
    const {
        toggleNotificationMenu,
        setNotificationMenu,
        notificationMenuOpen,
        rootStore,
        taskNotificationsStore,
        numOfNotifications
    } = globalTaskNotificationsStore;

    return (
            <div className="header__notification">
                <NotifyOutsideClick action={() => setNotificationMenu(false)}>
                    <div>
                        <div onClick={toggleNotificationMenu}>
                            {rootStore.userStore.user ? (
                                <div>
                                    <span className="header__notification">
                                        <i className="u-icon u-icon--med u-icon--bell"></i>
                                        <span className={`header__notification__counter ${numOfNotifications === 0 ? 'u-display--none' : ''}`}>{numOfNotifications}</span>
                                    </span>
                                </div>
                            ) : null}
                        </div>
                        <div className={'header__notification__dropdown' + (notificationMenuOpen ? ' active' : '')}>
                            <TaskNotifications store={taskNotificationsStore} /> 
                        </div>
                     </div>
                </NotifyOutsideClick>
            </div>
    );
}

GlobalTaskNotificationsTemplate.propTypes = {
    rootStore: PropTypes.object,
    routerStore: PropTypes.object,
    t: PropTypes.func,
    globalTaskNotificationsStore: PropTypes.object
};

export default defaultTemplate(GlobalTaskNotificationsTemplate);
